var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"tabWrap",class:_vm.$style.wrap},[_c('a-tabs',{class:_vm.$style.tabWrap,on:{"tabClick":_vm.select},model:{value:(_vm.activeKey),callback:function ($$v) {_vm.activeKey=$$v},expression:"activeKey"}},_vm._l((_vm.tabList),function(pane){
var _obj;
return _c('a-tab-pane',{key:pane.value},[_c('span',{class:[
          _vm.$style[_vm.colorText[pane.climbProcess]],
          ( _obj = {}, _obj[_vm.$style.active] = _vm.activeKey === pane.value, _obj ) ],attrs:{"slot":"tab"},slot:"tab"},[_vm._v(" "+_vm._s(pane.text)+" ")])])}),1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }